module.exports = __webpack_public_path__ + "img/rms-logo.70a80e26.png";